<script type="text/javascript">
// 定义一些公共的属性和方法
var map = null;
var lastZoom = 0;
var menu_overlay = null;
var point_overlay = null;
var mapCfg = null;
var bgColor="light";
var layerCfg = null;
var hyGisCfg = null;
var colorCfg = null;
var voltageLevel = null;
var layerStyleCfg = null;
var contextMenuCfg = null;
var heatLineAnimatonLayer = null;
var voltageLevelOptions = null;
var drawLineCfg = null;
var displayLabelLayer = null;
var tideWayVoltageLevel = null;
var tideWayModeStatus = null;
var tidwayFeatureAll = [];
var dataTypes = null;
var labelShow = true;
var weatherType = [];
var weatherTime = null;
var clickType = null
var weatherLayer = null
var windLayer = null
var eType = null
var weatherCfg = null
var gdljShow = null
var applicationScene = ""
var aisaLayerLayer = null
var topicName = [];
var topicCfg=null;
var appSceneCfg = null;
var asiaShow = false;
var showAllLines=true;
var venueIconShow=false;
var asiaCfg=null;
var curSpportZoom=0;
var globalControl=null;
var powerinfoShow=null;
var protectionElectricLayer=null;
var lighterOverlays=[];
var activeGridCode="0101330000";
var measureData=[];
var tree_overlay=null;
var bdDialogVisible=false;
var falgSource=null;
var falgLayer=null;
var qzbdMeasDisplayLayer=null;
var drawqzbdlc = null;
var qzbdInformationMeans = null;

function testLog(t) {
  console.log(t);
}
// 暴露出这些属性
export default {
  map,
  lastZoom,
  menu_overlay,
  point_overlay,
  mapCfg,
  layerCfg,
  hyGisCfg,
  layerStyleCfg,
  testLog,
  contextMenuCfg,
  heatLineAnimatonLayer,
  heatLineAnimatonLayer,
  voltageLevelOptions,
  drawLineCfg,
  displayLabelLayer,
  tideWayVoltageLevel,
  tideWayModeStatus,
  dataTypes,
  labelShow,
  tidwayFeatureAll,
  voltageLevel,
  colorCfg,
  weatherType,
  weatherTime,
  clickType,
  windLayer,
  weatherLayer,
  eType,
  weatherCfg,
  gdljShow,
  applicationScene,
  aisaLayerLayer,
  topicName,
  appSceneCfg,
  bgColor,
  topicCfg,
  asiaShow,
  showAllLines,
  venueIconShow,
  curSpportZoom,
  globalControl,
  powerinfoShow,
  asiaCfg,
  protectionElectricLayer,
  lighterOverlays,
  activeGridCode,
  measureData,
  tree_overlay,
  bdDialogVisible,
  falgLayer,
  falgSource,
  qzbdMeasDisplayLayer,
  drawqzbdlc,
  qzbdInformationMeans
};
</script>
